var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full text-sm leading-relaxed text-center"},[_c('h1',{staticClass:"text-xl font-bold"},[_vm._v("You're all done!")]),_c('br'),_c('p',[_vm._v("We have sent you an e-mail with a link.")]),_c('p',[_vm._v("Please click on that link to access the claim form.")])])
}]

export { render, staticRenderFns }